<template>
  <card>
    <div class="calendar-scroll">
      <vc-calendar
        class="custom-calendar max-w-full"
        :masks="masks"
        :attributes="attributes"
        locale="ru"
        :first-day-of-week="2"
        ref="calendar"
        @transition-start="change"
      >
        <template v-slot:day-content="{ day, attributes }">
          <div>
            <span>{{ day.day }}</span>

            <div
              class="vc-day-badge"
              :style="{ backgroundColor: attr.customData.discipline_color }"
              v-for="(attr, key) in attributes"
              :key="key"
              @click="openObject(attr.customData)"
            >
              <div v-if="holidays && !holidays[attr.customData.date]">
                <b>
                  {{ attr.customData.schedule_from_at | mmSecondToSecond }}</b
                >
                {{ attr.customData.discipline_title }} ({{
                  attr.customData.group_title
                }})
              </div>

              <div
                v-if="holidays && holidays[attr.customData.date] && key === 0"
              >
                🎉
                <p v-if="holidays[attr.customData.date].title">
                  {{ holidays[attr.customData.date].title }}
                </p>
                <small v-if="holidays[attr.customData.description]">
                  {{ holidays[attr.customData.date].description }}
                </small>
              </div>
            </div>
          </div>
        </template>
      </vc-calendar>
    </div>
  </card>
</template>

<script>
export default {
  created() {
    this.getTimetable();
  },
  methods: {
    openObject(item) {
      if (this.holidays[item.date]) {
        return false;
      }

      const element = "item_timetable";

      let query = Object.assign({}, this.$route.query);

      if (query[element] == item.id) {
        return false;
      }

      if (query[element]) {
        delete query[element];
      }

      query[element] = item.id;

      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
    change() {
      const calendar = this.$refs.calendar;

      let date = {};
      try {
        date = calendar.pages[0];
      } catch (error) {
        alert("Ошибка формирования даты");
        return false;
      }

      const month = date["month"];
      const year = date["year"];

      this.attributes = [];

      this.date = year + "-" + month + "-01";

      this.getTimetable();
    },
    async getTimetable() {
      this.$loading(true);
      await this.$http
        .get(`business/teacher/timetables?date=${this.date}`)
        .then((response) => {
          if (response.data && response.data.data) {
            let data = response.data.data;
            this.holidays = response.data.holidays;

            for (let i = 0; i < data.length; i++) {
              this.attributes.push({
                customData: data[i],
                dates: new Date(data[i]["date"]),
              });
            }
          }
        })
        .catch((error) => {
          // errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });
    },
  },
  data() {
    return {
      masks: {
        weekdays: "WW",
      },
      attributes: [],
      date: null,
      holidays: {},
    };
  },
};
</script>

<style lang="scss" >
.calendar-scroll {
  max-width: 100%;
  overflow-x: scroll;
}
.vc-container {
  text-align: center;
  border: none;
  border-radius: 0;
  width: 100%;
  & .vc-header {
    padding: 10px 0;
  }
  & .vc-weeks {
    padding: 0;
  }
  & .vc-weekday {
    font-size: 15px;
    font-weight: bold;
    color: #68b3c8;
    background-color: var(--weekday-bg);
    border-bottom: var(--weekday-border);
    border-top: var(--weekday-border);
    padding: 10px 0;
    text-transform: capitalize;
  }
  & .vc-day {
    border: 1px solid #ebebeb;
    text-align: center;
    min-height: 10vmax;
    min-width: 130px;
    font-size: 15px;
    font-weight: bold;
    background: #222;
    padding: 10px 5px 3px 10px;
    text-align: left;
    height: var(--day-height);
    width: var(--day-width);
    color: #111;
    background-color: white;
    &.weekday-1,
    &.weekday-7 {
      background-color: #eff8ff;
    }

    &:not(.on-bottom) {
      border-bottom: var(--day-border);
      &.weekday-1 {
        border-bottom: var(--day-border-highlight);
      }
    }
    &:not(.on-right) {
      border-right: var(--day-border);
    }

    & .vc-day-badge {
      cursor: pointer;
      font-size: 12px;
      color: #fff;
      border-radius: 5px;
      padding: 2px 5px;
      margin-top: 5px;
      line-height: 14px;
      font-weight: 500;
    }
  }
  & .vc-day-dots {
    margin-bottom: 5px;
    color: #111;
  }
}
</style>